import { apiClient } from '@/lib/api-client'

export interface RestoreEnvelopeParams {
  envelopeId: string
  vaultId: string
}

export const RESTORE_ENVELOPE_QUERY_KEYS = [
  'envelopes',
  'envelope',
  'vault-items',
]

export const restoreEnvelope = async ({
  envelopeId,
  vaultId,
}: RestoreEnvelopeParams): Promise<void> => {
  await apiClient.post(`/v1/ecm/envelopes/${envelopeId}/restore`, { vaultId })
}
